import { sectionRail } from "@/mocks/home";
import Reveal from "./Reveal";

const accentMap: Record<string, { bubble: string; text: string; ring: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    text: "text-primary-600",
    ring: "group-hover:border-primary-300",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-800",
    text: "text-accent-700",
    ring: "group-hover:border-accent-300",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-900",
    text: "text-secondary-700",
    ring: "group-hover:border-secondary-300",
  },
};

export default function SectionRail() {
  return (
    <section id="rail" className="w-full border-b border-background-200 bg-foreground-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <Reveal className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.35em] text-accent-400">SECTIONS</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">
              四个分区，一条拆解路径
            </h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-background-300">
            从整张长图到逐点对照，按这个顺序读，脉络会更清楚。
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {sectionRail.map((item, index) => {
            const tone = accentMap[item.accent] ?? accentMap.primary;
            return (
              <Reveal key={item.id} delay={index * 80}>
                <a
                  href="#featured"
                  className={`group flex h-full cursor-pointer flex-col rounded-lg border border-background-800 bg-foreground-900 p-5 transition-colors duration-300 ${tone.ring}`}
                >
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-md ${tone.bubble} transition-transform duration-300 group-hover:-translate-y-0.5`}
                  >
                    <i className={`${item.icon} text-2xl`} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-bold text-background-50">{item.title}</h3>
                  <p className="mt-2 flex-1 font-body text-sm leading-relaxed text-background-400">{item.desc}</p>
                  <span className={`mt-4 flex items-center gap-2 font-label text-xs ${tone.text}`}>
                    {item.count}
                    <i className="ri-arrow-right-up-line" />
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}